import { TAGS, TAG_DISPLAY_TEXT } from '~/constants/edf';

class AnnotationTreeNode {
    constructor(tag, displayText) {
        this.children = [];
        this.parent = null;
        this.tag = tag;
        this.displayText = displayText;
    }

    setParent(parent) {
        this.parent = parent;
    }

    addChild(child) {
        this.children.push(child);
    }
}

class AnnotationTree {
    constructor() {
        this.root = new AnnotationTreeNode('root');
        this.index = {
            root: this.root,
        };
    }

    addRootChild(node) {
        node.setParent(this.root);
        this.root.addChild(node);
        this.index[node.tag] = node;
    }

    addChildToTag(tag, node) {
        const parent = this.index[tag];
        node.setParent(parent);
        parent.addChild(node);
        this.index[node.tag] = node;
    }

    findTag(tag) {
        return this.index[tag];
    }

    getChildrenForTag(tag) {
        return this.index[tag].children;
    }
}

const tree = new AnnotationTree();

// region seed tree
tree.addRootChild(new AnnotationTreeNode(TAGS.COMMENT, TAG_DISPLAY_TEXT.COMMENT));

tree.addRootChild(new AnnotationTreeNode(TAGS.EVENT, TAG_DISPLAY_TEXT.EVENT));
tree.addChildToTag(
    TAGS.EVENT,
    new AnnotationTreeNode(TAGS.RESPIRATORY, TAG_DISPLAY_TEXT.RESPIRATORY)
);
tree.addChildToTag(
    TAGS.EVENT,
    new AnnotationTreeNode(TAGS.DESATURATION, TAG_DISPLAY_TEXT.DESATURATION)
);
tree.addChildToTag(
    TAGS.RESPIRATORY,
    new AnnotationTreeNode(TAGS.CENTRAL, TAG_DISPLAY_TEXT.CENTRAL)
);
tree.addChildToTag(
    TAGS.RESPIRATORY,
    new AnnotationTreeNode(TAGS.OBSTRUCTIVE, TAG_DISPLAY_TEXT.OBSTRUCTIVE)
);
tree.addChildToTag(TAGS.CENTRAL, new AnnotationTreeNode(TAGS.APNEA, TAG_DISPLAY_TEXT.APNEA));
tree.addChildToTag(TAGS.CENTRAL, new AnnotationTreeNode(TAGS.HYPOPNEA, TAG_DISPLAY_TEXT.HYPOPNEA));
tree.addChildToTag(TAGS.OBSTRUCTIVE, new AnnotationTreeNode(TAGS.APNEA, TAG_DISPLAY_TEXT.APNEA));
tree.addChildToTag(
    TAGS.OBSTRUCTIVE,
    new AnnotationTreeNode(TAGS.HYPOPNEA, TAG_DISPLAY_TEXT.HYPOPNEA)
);

tree.addRootChild(new AnnotationTreeNode(TAGS.POSITION, TAG_DISPLAY_TEXT.POSITION));
tree.addChildToTag(TAGS.POSITION, new AnnotationTreeNode(TAGS.SUPINE, TAG_DISPLAY_TEXT.SUPINE));
tree.addChildToTag(TAGS.POSITION, new AnnotationTreeNode(TAGS.UPRIGHT, TAG_DISPLAY_TEXT.UPRIGHT));
tree.addChildToTag(
    TAGS.POSITION,
    new AnnotationTreeNode(TAGS.NONSUPINE, TAG_DISPLAY_TEXT.NONSUPINE)
);

tree.addRootChild(new AnnotationTreeNode(TAGS.SIGNAL, TAG_DISPLAY_TEXT.SIGNAL));
tree.addChildToTag(TAGS.SIGNAL, new AnnotationTreeNode(TAGS.DROPOUT, TAG_DISPLAY_TEXT.DROPOUT));
tree.addChildToTag(TAGS.SIGNAL, new AnnotationTreeNode(TAGS.ARTIFACT, TAG_DISPLAY_TEXT.ARTIFACT));
tree.addChildToTag(TAGS.ARTIFACT, new AnnotationTreeNode(TAGS.MOTION, TAG_DISPLAY_TEXT.MOTION));

tree.addRootChild(new AnnotationTreeNode(TAGS.HYPNOGRAM, TAG_DISPLAY_TEXT.HYPNOGRAM));
tree.addChildToTag(TAGS.HYPNOGRAM, new AnnotationTreeNode(TAGS.N1, TAG_DISPLAY_TEXT.N1));
tree.addChildToTag(TAGS.HYPNOGRAM, new AnnotationTreeNode(TAGS.N2, TAG_DISPLAY_TEXT.N2));
tree.addChildToTag(TAGS.HYPNOGRAM, new AnnotationTreeNode(TAGS.N3, TAG_DISPLAY_TEXT.N3));
tree.addChildToTag(TAGS.HYPNOGRAM, new AnnotationTreeNode(TAGS.REM, TAG_DISPLAY_TEXT.REM));
tree.addChildToTag(TAGS.HYPNOGRAM, new AnnotationTreeNode(TAGS.WAKE, TAG_DISPLAY_TEXT.WAKE));
// endregion

const AVAILABLE_ANNOTATIONS = [
    TAGS.COMMENT,
    TAGS.RESPIRATORY,
    TAGS.DESATURATION,
    TAGS.MOTION,
    TAGS.DROPOUT,
];

export const getSiblingTags = (tag) =>
    tree.findTag(tag).parent.children.map((childTag) => ({
        value: childTag.tag,
        displayText: childTag.displayText,
    }));
export const hasParentTag = (currentTag, searchingTag) => {
    const parent = tree.findTag(currentTag).parent;

    if (parent === null) {
        return false;
    }

    if (parent.tag === searchingTag) {
        return true;
    }

    return hasParentTag(parent.tag, searchingTag);
};
export const getParentTag = (tag) => tree.findTag(tag).parent.tag;
export const getFriendlyLabelForTag = (tag, ) => tree.findTag(tag).displayText;
export const availableAnnotations = AVAILABLE_ANNOTATIONS.map((tag) => ({
    value: tag,
    displayText: getFriendlyLabelForTag(tag),
}));
export const availableAnnotationsForSettings = [
    { value: TAGS.COMMENT, displayText: 'Comment' },
    { value: TAGS.RESPIRATORY, displayText: 'Respiratory Events' },
    { value: TAGS.DESATURATION, displayText: 'Desaturation Events' },
    { value: TAGS.MOTION, displayText: 'Motion and Wake' },
    { value: TAGS.DROPOUT, displayText: 'Signal Loss' },
];
